export enum EnumFaturaStatus {
    ABERTA = 0,
    PAGA = 1,
    CANCELADA = 2,
    REJEITADA = 3,
    FECHADO = 4,
    EMATRASO = 5,
    BONIFICADA = 6,
}